import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GatewayDeployment } from '../../../domain/gateway-deployment.interface';
import { GridxDeviceService } from '../../../services/gridx-device.service';
import * as dayjs from 'dayjs';
import { Router } from "@angular/router";
import { ImageOSVersion } from '../../../domain/image-osversion.interface';
import { Dayjs } from 'dayjs';
import {AuthService} from "../../../services/auth.service";

@Component({
  selector: 'eis-gateway-gateway-image-version',
  templateUrl: './gateway-image-version.component.html',
  styleUrls: ['./gateway-image-version.component.scss']
})
export class GatewayImageVersionComponent implements OnInit, OnChanges {

  @Input()
  gateway: GatewayDeployment

  @Input()
  latestImageOSVersion: ImageOSVersion

  public currentImageName: string;
  public currentImageFormattedDate: string | undefined;
  public hasImageUpdate: boolean = false;
  public differenceInDays: number | undefined;
  public loading: boolean = false;
  @Input() isAdmin: boolean;

  constructor(private authService: AuthService,
              public router: Router) {
  }

  ngOnChanges(changes: SimpleChanges): void {
        if(changes['gateway'].currentValue) {
          if(this.gateway.imageDate) {
            this.currentImageFormattedDate = dayjs(this.gateway.imageDate).format("YYYYMMDD");
          } else {
            this.currentImageFormattedDate = this.gateway.imageVersion;
          }

          this.hasImageUpdate = this.hasNewImage();
        }
    }

  ngOnInit(): void {
    this.currentImageName = this.gateway.imageVersion;
  }

  private hasNewImage() {
    const latestImageDate = dayjs(this.latestImageOSVersion.imageDate);

    if(this.gateway.imageDate != null && latestImageDate != null) {
      this.differenceInDays = latestImageDate?.diff(this.gateway.imageDate, 'day');
      return dayjs(this.gateway.imageDate).isBefore(latestImageDate);
    }

    return false;
  }

  openGatewayConfig($event: MouseEvent): void {
    $event.stopPropagation();
    this.router.navigate(['gateway/' + this.gateway.gatewaySerial + '/config/softwareupdate'])
  }

  doNothingAndLog($event: MouseEvent) {
    $event.stopPropagation();
    console.log("doNothingAndLog...");
    //doNothing
  }
}
